import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Button, ThemeProvider, createTheme } from "@mui/material";
import facebook from "../../assets/facebook.svg";
import instagram from "../../assets/instagram.svg";
import soundcloud from "../../assets/soundcloud.svg";
import { Link } from "react-router-dom";
import { useInfo } from "../../hooks/useInfo";
import {
  AppBarSx,
  ButtonSx,
  ContainerSx,
  FooterBox2Sx,
  FooterBoxSx,
  socialIconSx,
} from "./FooterStyles";

const navItems = [
  { label: "EVENTS", path: "/events" },
  { label: "ARTISTS", path: "/artists" },
  { label: "CONTACT", path: "/contact" },
  { label: "ABOUT US", path: "/about" },
];

const socialIcons = [
  { icon: facebook, name: "facebook" },
  { icon: instagram, name: "instagram" },
  { icon: soundcloud, name: "soundcloud" },
];

const theme = createTheme({
  palette: {
    primary: { main: "#000" },
    secondary: { main: "#f50057" },
  },
});

const ResponsiveFooter = () => {
  const { data: info } = useInfo();

  return (
    <ThemeProvider theme={theme}>
      <Container  position="static" sx={AppBarSx}>
        <Container maxWidth="xl" sx={ContainerSx}>
          <Box sx={FooterBoxSx}>
            {navItems.map(({ label, path }) => (
              <Link key={label} to={path} style={{ textDecoration: "none" }}>
                <Button sx={ButtonSx}>{label}</Button>
              </Link>
            ))}
          </Box>
          <Box sx={FooterBox2Sx}>
            {socialIcons.map(({ name, icon }) => (
              <Box
                key={name}
                component="a"
                href={info?.[name] || "#"}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "inline-flex", opacity: info?.[name] ? 1 : 0.3, cursor: info?.[name] ? "pointer" : "default" }}
              >
                <Box component="img" src={icon} alt={name} sx={socialIconSx} />
              </Box>
            ))}
          </Box>
        </Container>
      </Container>
    </ThemeProvider>
  );
};

export default ResponsiveFooter;
